import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Appointment } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class AppointmentModule extends VuexModule {
    @Action
    [Appointment.findPageAppointment](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/appointment/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Appointment.saveAppointment](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/appointment/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Appointment.deleteAppointment](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/appointment/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}